import request from './request'

/** 获取服务配置 */
export const getServicoConfig = () => {
  return request({
    url: '/carbon-misc/public/web/config/customer/service',
    method: 'GET'
  })
}

/** 获取安装配置 */
export const getInstallConfig = (options: any = {}) => {
  return request({
    url: '/carbon-misc/public/web/config/install/boot',
    method: 'GET',
    params: options
  })
}

/** 获取webpush配置 */
export const getWebpushConfig = () => {
  return request({
    url: '/carbon-misc/public/web/config/web/push',
    method: 'GET'
  })
}

/** 获取图片基础地址 */
export const getMerchantConfig = () => {
  return request({
    url: '/carbon-auth/public/common/preload',
    method: 'GET'
  })
}